﻿/*global DataCoverage:true */

var DataCoverage = DataCoverage || {};

DataCoverage.countries = [
    {
        "iso3": "ABW",
        "iso2": "AW",
        "name": "Aruba",
        "grade": "B"
    },
    {
        "iso3": "AFG",
        "iso2": "AF",
        "name": "Afghanistan",
        "grade": "B"
    },
    {
        "iso3": "AGO",
        "iso2": "AO",
        "name": "Angola",
        "grade": "B"
    },
    {
        "iso3": "ALB",
        "iso2": "AL",
        "name": "Albania",
        "grade": "B"
    },
    {
        "iso3": "AND",
        "iso2": "AD",
        "name": "Andorra",
        "grade": "B"
    },
    /* "Netherlands Antilles" no longer exists. http://en.wikipedia.org/wiki/Netherlands_Antilles
    {
        "iso3": "ANT",
        "iso2": "AN",
        "name": "Netherlands Antilles",
        "grade": "B"
    },*/
    {
        "iso3": "ARE",
        "iso2": "AE",
        "name": "United Arab Emirates",
        "grade": "B"
    },
    {
        "iso3": "ARG",
        "iso2": "AR",
        "name": "Argentina",
        "grade": "A+"
    },
    {
        "iso3": "ARM",
        "iso2": "AM",
        "name": "Armenia",
        "grade": "A"
    },
    {
        "iso3": "ASM",
        "iso2": "AS",
        "name": "American Samoa",
        "grade": "A"
    },
    {
        "iso3": "ATA",
        "iso2": "AQ",
        "name": "Antarctica",
        "grade": "B"
    },
    {
        "iso3": "ATF",
        "iso2": "TF",
        "name": "French Southern Territories",
        "grade": "A+"
    },
    {
        "iso3": "ATG",
        "iso2": "AG",
        "name": "Antigua and Barbuda",
        "grade": "B"
    },
    {
        "iso3": "AUS",
        "iso2": "AU",
        "name": "Australia",
        "grade": "A+"
    },
    {
        "iso3": "AUT",
        "iso2": "AT",
        "name": "Austria",
        "grade": "A+"
    },
    {
        "iso3": "AZE",
        "iso2": "AZ",
        "name": "Azerbaijan",
        "grade": "B"
    },
    {
        "iso3": "BDI",
        "iso2": "BI",
        "name": "Burundi",
        "grade": "B"
    },
    {
        "iso3": "BEL",
        "iso2": "BE",
        "name": "Belgium",
        "grade": "A+"
    },
    {
        "iso3": "BEN",
        "iso2": "BJ",
        "name": "Benin",
        "grade": "B"
    },
    {
        "iso3": "BES",
        "iso2": "BQ",
        "name": "Caribbean Netherlands",
        "grade": "B"
    },
    {
        "iso3": "BFA",
        "iso2": "BF",
        "name": "Burkina Faso",
        "grade": "B"
    },
    {
        "iso3": "BGD",
        "iso2": "BD",
        "name": "Bangladesh",
        "grade": "A"
    },
    {
        "iso3": "BGR",
        "iso2": "BG",
        "name": "Bulgaria",
        "grade": "B"
    },
    {
        "iso3": "BHR",
        "iso2": "BH",
        "name": "Bahrain",
        "grade": "B"
    },
    {
        "iso3": "BHS",
        "iso2": "BS",
        "name": "Bahamas",
        "grade": "B"
    },
    {
        "iso3": "BIH",
        "iso2": "BA",
        "name": "Bosnia and Herzegovina",
        "grade": "B"
    },
    {
        "iso3": "BLM",
        "iso2": "BL",
        "name": "Saint Barthélemy",
        "grade": "A+"
    },
    {
        "iso3": "BLR",
        "iso2": "BY",
        "name": "Belarus",
        "grade": "A"
    },
    {
        "iso3": "BLZ",
        "iso2": "BZ",
        "name": "Belize",
        "grade": "B"
    },
    {
        "iso3": "BMU",
        "iso2": "BM",
        "name": "Bermuda",
        "grade": "A+"
    },
    {
        "iso3": "BOL",
        "iso2": "BO",
        "name": "Bolivia",
        "grade": "B"
    },
    {
        "iso3": "BRA",
        "iso2": "BR",
        "name": "Brazil",
        "grade": "A+"
    },
    {
        "iso3": "BRB",
        "iso2": "BB",
        "name": "Barbados",
        "grade": "B"
    },
    {
        "iso3": "BRN",
        "iso2": "BN",
        "name": "Brunei Darussalam",
        "grade": "A"
    },
    {
        "iso3": "BTN",
        "iso2": "BT",
        "name": "Bhutan",
        "grade": "B"
    },
    {
        "iso3": "BVT",
        "iso2": "BV",
        "name": "Bouvet Island",
        "grade": "A"
    },
    {
        "iso3": "BWA",
        "iso2": "BW",
        "name": "Botswana",
        "grade": "B"
    },
    {
        "iso3": "CAF",
        "iso2": "CF",
        "name": "Central African Republic",
        "grade": "B"
    },
    {
        "iso3": "CAN",
        "iso2": "CA",
        "name": "Canada",
        "grade": "A+"
    },
    {
        "iso3": "CCK",
        "iso2": "CC",
        "name": "Cocos Islands",
        "grade": "B"
    },
    {
        "iso3": "CHE",
        "iso2": "CH",
        "name": "Switzerland",
        "grade": "A+"
    },
    {
        "iso3": "CHL",
        "iso2": "CL",
        "name": "Chile",
        "grade": "A"
    },
    {
        "iso3": "CHN",
        "iso2": "CN",
        "name": "China",
        "grade": "A"
    },
    {
        "iso3": "CIV",
        "iso2": "CI",
        "name": "Côte d'Ivoire",
        "grade": "B"
    },
    {
        "iso3": "CMR",
        "iso2": "CM",
        "name": "Cameroon",
        "grade": "B"
    },
    {
        "iso3": "COD",
        "iso2": "CD",
        "name": "Congo, The Democratic Republic of the",
        "grade": "B"
    },
    {
        "iso3": "COG",
        "iso2": "CG",
        "name": "Congo",
        "grade": "B"
    },
    {
        "iso3": "COK",
        "iso2": "CK",
        "name": "Cook Islands",
        "grade": "B"
    },
    {
        "iso3": "COL",
        "iso2": "CO",
        "name": "Colombia",
        "grade": "B"
    },
    {
        "iso3": "COM",
        "iso2": "KM",
        "name": "Comoros",
        "grade": "B"
    },
    {
        "iso3": "CPV",
        "iso2": "CV",
        "name": "Cape Verde",
        "grade": "B"
    },
    {
        "iso3": "CRI",
        "iso2": "CR",
        "name": "Costa Rica",
        "grade": "B"
    },
    {
        "iso3": "CUB",
        "iso2": "CU",
        "name": "Cuba",
        "grade": "B"
    },
    {
        "iso3": "CUW",
        "iso2": "CW",
        "name": "Curaçao",
        "grade": "B"
    },
    {
        "iso3": "CXR",
        "iso2": "CX",
        "name": "Christmas Island",
        "grade": "B"
    },
    {
        "iso3": "CYM",
        "iso2": "KY",
        "name": "Cayman Islands",
        "grade": "B"
    },
    {
        "iso3": "CYP",
        "iso2": "CY",
        "name": "Cyprus",
        "grade": "A+"
    },
    {
        "iso3": "CZE",
        "iso2": "CZ",
        "name": "Czech Republic",
        "grade": "A"
    },
    {
        "iso3": "DEU",
        "iso2": "DE",
        "name": "Germany",
        "grade": "A+"
    },
    {
        "iso3": "DJI",
        "iso2": "DJ",
        "name": "Djibouti",
        "grade": "B"
    },
    {
        "iso3": "DMA",
        "iso2": "DM",
        "name": "Dominica",
        "grade": "B"
    },
    {
        "iso3": "DNK",
        "iso2": "DK",
        "name": "Denmark",
        "grade": "A+"
    },
    {
        "iso3": "DOM",
        "iso2": "DO",
        "name": "Dominican Republic",
        "grade": "A+"
    },
    {
        "iso3": "DZA",
        "iso2": "DZ",
        "name": "Algeria",
        "grade": "B"
    },
    {
        "iso3": "ECU",
        "iso2": "EC",
        "name": "Ecuador",
        "grade": "B"
    },
    {
        "iso3": "EGY",
        "iso2": "EG",
        "name": "Egypt",
        "grade": "B"
    },
    {
        "iso3": "ERI",
        "iso2": "ER",
        "name": "Eritrea",
        "grade": "B"
    },
    {
        "iso3": "ESH",
        "iso2": "EH",
        "name": "Western Sahara",
        "grade": "B"
    },
    {
        "iso3": "ESP",
        "iso2": "ES",
        "name": "Spain",
        "grade": "A"
    },
    {
        "iso3": "EST",
        "iso2": "EE",
        "name": "Estonia",
        "grade": "A+"
    },
    {
        "iso3": "ETH",
        "iso2": "ET",
        "name": "Ethiopia",
        "grade": "B"
    },
    {
        "iso3": "FIN",
        "iso2": "FI",
        "name": "Finland",
        "grade": "A+"
    },
    {
        "iso3": "FJI",
        "iso2": "FJ",
        "name": "Fiji",
        "grade": "B"
    },
    {
        "iso3": "FRA",
        "iso2": "FR",
        "name": "France",
        "grade": "A+"
    },
    {
        "iso3": "FRO",
        "iso2": "FO",
        "name": "Faroe Islands",
        "grade": "B"
    },
    {
        "iso3": "FSM",
        "iso2": "FM",
        "name": "Micronesia, Federated States of",
        "grade": "A"
    },
    {
        "iso3": "GAB",
        "iso2": "GA",
        "name": "Gabon",
        "grade": "B"
    },
    {
        "iso3": "GBR",
        "iso2": "GB",
        "name": "United Kingdom",
        "grade": "A+"
    },
    {
        "iso3": "GEO",
        "iso2": "GE",
        "name": "Georgia",
        "grade": "B"
    },
    {
        "iso3": "GGY",
        "iso2": "GG",
        "name": "Guernsey",
        "grade": "A+"
    },
    {
        "iso3": "GHA",
        "iso2": "GH",
        "name": "Ghana",
        "grade": "B"
    },
    {
        "iso3": "GIN",
        "iso2": "GN",
        "name": "Guinea",
        "grade": "B"
    },
    {
        "iso3": "GLP",
        "iso2": "GP",
        "name": "Guadeloupe",
        "grade": "A+"
    },
    {
        "iso3": "GMB",
        "iso2": "GM",
        "name": "Gambia",
        "grade": "B"
    },
    {
        "iso3": "GNB",
        "iso2": "GW",
        "name": "Guinea-Bissau",
        "grade": "B"
    },
    {
        "iso3": "GNQ",
        "iso2": "GQ",
        "name": "Equatorial Guinea",
        "grade": "B"
    },
    {
        "iso3": "GRC",
        "iso2": "GR",
        "name": "Greece",
        "grade": "A"
    },
    {
        "iso3": "GRD",
        "iso2": "GD",
        "name": "Grenada",
        "grade": "B"
    },
    {
        "iso3": "GRL",
        "iso2": "GL",
        "name": "Greenland",
        "grade": "A+"
    },
    {
        "iso3": "GTM",
        "iso2": "GT",
        "name": "Guatemala",
        "grade": "A"
    },
    {
        "iso3": "GUF",
        "iso2": "GF",
        "name": "French Guiana",
        "grade": "A+"
    },
    {
        "iso3": "GUM",
        "iso2": "GU",
        "name": "Guam",
        "grade": "A+"
    },
    {
        "iso3": "GUY",
        "iso2": "GY",
        "name": "Guyana",
        "grade": "B"
    },
    {
        "iso3": "HKG",
        "iso2": "HK",
        "name": "Hong Kong",
        "grade": "A+"
    },
    {
        "iso3": "HMD",
        "iso2": "HM",
        "name": "Heard Island and McDonald Islands",
        "grade": "A+"
    },
    {
        "iso3": "HND",
        "iso2": "HN",
        "name": "Honduras",
        "grade": "B"
    },
    {
        "iso3": "HRV",
        "iso2": "HR",
        "name": "Croatia",
        "grade": "B"
    },
    {
        "iso3": "HTI",
        "iso2": "HT",
        "name": "Haiti",
        "grade": "A"
    },
    {
        "iso3": "HUN",
        "iso2": "HU",
        "name": "Hungary",
        "grade": "A"
    },
    {
        "iso3": "IDN",
        "iso2": "ID",
        "name": "Indonesia",
        "grade": "A+"
    },
    {
        "iso3": "IMN",
        "iso2": "IM",
        "name": "Isle of Man",
        "grade": "A+"
    },
    {
        "iso3": "IND",
        "iso2": "IN",
        "name": "India",
        "grade": "A"
    },
    {
        "iso3": "IRL",
        "iso2": "IE",
        "name": "Ireland",
        "grade": "A"
    },
    {
        "iso3": "IRN",
        "iso2": "IR",
        "name": "Iran, Islamic Republic of",
        "grade": "B"
    },
    {
        "iso3": "IRQ",
        "iso2": "IQ",
        "name": "Iraq",
        "grade": "B"
    },
    {
        "iso3": "ISL",
        "iso2": "IS",
        "name": "Iceland",
        "grade": "A"
    },
    {
        "iso3": "ISR",
        "iso2": "IL",
        "name": "Israel",
        "grade": "B"
    },
    {
        "iso3": "ITA",
        "iso2": "IT",
        "name": "Italy",
        "grade": "A+"
    },
    {
        "iso3": "JAM",
        "iso2": "JM",
        "name": "Jamaica",
        "grade": "B"
    },
    {
        "iso3": "JEY",
        "iso2": "JE",
        "name": "Jersey",
        "grade": "A+"
    },
    {
        "iso3": "JOR",
        "iso2": "JO",
        "name": "Jordan",
        "grade": "B"
    },
    {
        "iso3": "JPN",
        "iso2": "JP",
        "name": "Japan",
        "grade": "A+"
    },
    {
        "iso3": "KAZ",
        "iso2": "KZ",
        "name": "Kazakhstan",
        "grade": "B"
    },
    {
        "iso3": "KEN",
        "iso2": "KE",
        "name": "Kenya",
        "grade": "B"
    },
    {
        "iso3": "KGZ",
        "iso2": "KG",
        "name": "Kyrgyzstan",
        "grade": "B"
    },
    {
        "iso3": "KHM",
        "iso2": "KH",
        "name": "Cambodia",
        "grade": "B"
    },
    {
        "iso3": "KIR",
        "iso2": "KI",
        "name": "Kiribati",
        "grade": "B"
    },
    {
        "iso3": "KNA",
        "iso2": "KN",
        "name": "Saint Kitts and Nevis",
        "grade": "B"
    },
    {
        "iso3": "KOR",
        "iso2": "KR",
        "name": "Korea, Republic of",
        "grade": "A"
    },
    {
        "iso3": "KWT",
        "iso2": "KW",
        "name": "Kuwait",
        "grade": "B"
    },
    {
        "iso3": "LAO",
        "iso2": "LA",
        "name": "Lao, People's Democratic Republic",
        "grade": "B"
    },
    {
        "iso3": "LBN",
        "iso2": "LB",
        "name": "Lebanon",
        "grade": "B"
    },
    {
        "iso3": "LBR",
        "iso2": "LR",
        "name": "Liberia",
        "grade": "B"
    },
    {
        "iso3": "LBY",
        "iso2": "LY",
        "name": "Libyan Arab Jamahiriya",
        "grade": "B"
    },
    {
        "iso3": "LIE",
        "iso2": "LI",
        "name": "Liechtenstein",
        "grade": "A+"
    },
    {
        "iso3": "LKA",
        "iso2": "LK",
        "name": "Sri Lanka",
        "grade": "B"
    },
    {
        "iso3": "LSO",
        "iso2": "LS",
        "name": "Lesotho",
        "grade": "B"
    },
    {
        "iso3": "LTU",
        "iso2": "LT",
        "name": "Lithuania",
        "grade": "A"
    },
    {
        "iso3": "LUX",
        "iso2": "LU",
        "name": "Luxembourg",
        "grade": "A+"
    },
    {
        "iso3": "LVA",
        "iso2": "LV",
        "name": "Latvia",
        "grade": "A"
    },
    {
        "iso3": "MAF",
        "iso2": "MF",
        "name": "Saint Martin",
        "grade": "A+"
    },
    {
        "iso3": "MAR",
        "iso2": "MA",
        "name": "Morocco",
        "grade": "A"
    },
    {
        "iso3": "MCO",
        "iso2": "MC",
        "name": "Monaco",
        "grade": "A"
    },
    {
        "iso3": "MDA",
        "iso2": "MD",
        "name": "Moldova",
        "grade": "A"
    },
    {
        "iso3": "MDG",
        "iso2": "MG",
        "name": "Madagascar",
        "grade": "B"
    },
    {
        "iso3": "MDV",
        "iso2": "MV",
        "name": "Maldives",
        "grade": "A"
    },
    {
        "iso3": "MEX",
        "iso2": "MX",
        "name": "Mexico",
        "grade": "A"
    },
    {
        "iso3": "MHL",
        "iso2": "MH",
        "name": "Marshall Islands",
        "grade": "A"
    },
    {
        "iso3": "MKD",
        "iso2": "MK",
        "name": "Macedonia, The Former Yugoslav Republic of",
        "grade": "B"
    },
    {
        "iso3": "MLI",
        "iso2": "ML",
        "name": "Mali",
        "grade": "B"
    },
    {
        "iso3": "MLT",
        "iso2": "MT",
        "name": "Malta",
        "grade": "A"
    },
    {
        "iso3": "MMR",
        "iso2": "MM",
        "name": "Myanmar",
        "grade": "B"
    },
    {
        "iso3": "MNE",
        "iso2": "ME",
        "name": "Montenegro",
        "grade": "B"
    },
    {
        "iso3": "MNG",
        "iso2": "MN",
        "name": "Mongolia",
        "grade": "B"
    },
    {
        "iso3": "MNP",
        "iso2": "MP",
        "name": "Northern Mariana Islands",
        "grade": "A"
    },
    {
        "iso3": "MOZ",
        "iso2": "MZ",
        "name": "Mozambique",
        "grade": "B"
    },
    {
        "iso3": "MRT",
        "iso2": "MR",
        "name": "Mauritania",
        "grade": "B"
    },
    {
        "iso3": "MTQ",
        "iso2": "MQ",
        "name": "Martinique",
        "grade": "A+"
    },
    {
        "iso3": "MUS",
        "iso2": "MU",
        "name": "Mauritius",
        "grade": "B"
    },
    {
        "iso3": "MWI",
        "iso2": "MW",
        "name": "Malawi",
        "grade": "B"
    },
    {
        "iso3": "MYS",
        "iso2": "MY",
        "name": "Malaysia",
        "grade": "A"
    },
    {
        "iso3": "MYT",
        "iso2": "YT",
        "name": "Mayotte",
        "grade": "A+"
    },
    {
        "iso3": "NAM",
        "iso2": "NA",
        "name": "Namibia",
        "grade": "B"
    },
    {
        "iso3": "NCL",
        "iso2": "NC",
        "name": "New Caledonia",
        "grade": "B"
    },
    {
        "iso3": "NER",
        "iso2": "NE",
        "name": "Niger",
        "grade": "B"
    },
    {
        "iso3": "NFK",
        "iso2": "NF",
        "name": "Norfolk Island",
        "grade": "B"
    },
    {
        "iso3": "NGA",
        "iso2": "NG",
        "name": "Nigeria",
        "grade": "B"
    },
    {
        "iso3": "NIC",
        "iso2": "NI",
        "name": "Nicaragua",
        "grade": "B"
    },
    {
        "iso3": "NIU",
        "iso2": "NU",
        "name": "Niue",
        "grade": "B"
    },
    {
        "iso3": "NLD",
        "iso2": "NL",
        "name": "Netherlands",
        "grade": "A+"
    },
    {
        "iso3": "NOR",
        "iso2": "NO",
        "name": "Norway",
        "grade": "A"
    },
    {
        "iso3": "NPL",
        "iso2": "NP",
        "name": "Nepal",
        "grade": "B"
    },
    {
        "iso3": "NRU",
        "iso2": "NR",
        "name": "Nauru",
        "grade": "B"
    },
    {
        "iso3": "NZL",
        "iso2": "NZ",
        "name": "New Zealand",
        "grade": "A+"
    },
    {
        "iso3": "OMN",
        "iso2": "OM",
        "name": "Oman",
        "grade": "B"
    },
    {
        "iso3": "PAK",
        "iso2": "PK",
        "name": "Pakistan",
        "grade": "B"
    },
    {
        "iso3": "PAN",
        "iso2": "PA",
        "name": "Panama",
        "grade": "B"
    },
    {
        "iso3": "PER",
        "iso2": "PE",
        "name": "Peru",
        "grade": "B"
    },
    {
        "iso3": "PHL",
        "iso2": "PH",
        "name": "Philippines",
        "grade": "A"
    },
    {
        "iso3": "PLW",
        "iso2": "PW",
        "name": "Palau",
        "grade": "A"
    },
    {
        "iso3": "PNG",
        "iso2": "PG",
        "name": "Papua New Guinea",
        "grade": "B"
    },
    {
        "iso3": "POL",
        "iso2": "PL",
        "name": "Poland",
        "grade": "A"
    },
    {
        "iso3": "PRI",
        "iso2": "PR",
        "name": "Puerto Rico",
        "grade": "A+"
    },
    {
        "iso3": "PRK",
        "iso2": "KP",
        "name": "Korea, Democratic People's Republic of",
        "grade": "B"
    },
    {
        "iso3": "PRT",
        "iso2": "PT",
        "name": "Portugal",
        "grade": "A+"
    },
    {
        "iso3": "PRY",
        "iso2": "PY",
        "name": "Paraguay",
        "grade": "A+"
    },
    {
        "iso3": "PYF",
        "iso2": "PF",
        "name": "French Polynesia",
        "grade": "B"
    },
    {
        "iso3": "QAT",
        "iso2": "QA",
        "name": "Qatar",
        "grade": "B"
    },
    {
        "iso3": "REU",
        "iso2": "RE",
        "name": "Réunion",
        "grade": "A+"
    },
    {
        "iso3": "ROU",
        "iso2": "RO",
        "name": "Romania",
        "grade": "A"
    },
    {
        "iso3": "RUS",
        "iso2": "RU",
        "name": "Russian Federation",
        "grade": "A+"
    },
    {
        "iso3": "RWA",
        "iso2": "RW",
        "name": "Rwanda",
        "grade": "B"
    },
    {
        "iso3": "SAU",
        "iso2": "SA",
        "name": "Saudi Arabia",
        "grade": "B"
    },
    {
        "iso3": "SDN",
        "iso2": "SD",
        "name": "Sudan",
        "grade": "B"
    },
    {
        "iso3": "SEN",
        "iso2": "SN",
        "name": "Senegal",
        "grade": "B"
    },
    {
        "iso3": "SGP",
        "iso2": "SG",
        "name": "Singapore",
        "grade": "A+"
    },
    {
        "iso3": "SJM",
        "iso2": "SJ",
        "name": "Svalbard and Jan Mayen",
        "grade": "B"
    },
    {
        "iso3": "SLB",
        "iso2": "SB",
        "name": "Solomon Islands",
        "grade": "B"
    },
    {
        "iso3": "SLE",
        "iso2": "SL",
        "name": "Sierra Leone",
        "grade": "B"
    },
    {
        "iso3": "SLV",
        "iso2": "SV",
        "name": "El Salvador",
        "grade": "B"
    },
    {
        "iso3": "SMR",
        "iso2": "SM",
        "name": "San Marino",
        "grade": "B"
    },
    {
        "iso3": "SOM",
        "iso2": "SO",
        "name": "Somalia",
        "grade": "B"
    },
    {
        "iso3": "SPM",
        "iso2": "PM",
        "name": "Saint Pierre and Miquelon",
        "grade": "B"
    },
    {
        "iso3": "SRB",
        "iso2": "RS",
        "name": "Serbia",
        "grade": "B"
    },
    {
        "iso3": "SSD",
        "iso2": "SS",
        "name": "South Sudan",
        "grade": "B"
    },
    {
        "iso3": "STP",
        "iso2": "ST",
        "name": "Sao Tome and Principe",
        "grade": "B"
    },
    {
        "iso3": "SUR",
        "iso2": "SR",
        "name": "Suriname",
        "grade": "B"
    },
    {
        "iso3": "SVK",
        "iso2": "SK",
        "name": "Slovakia",
        "grade": "A"
    },
    {
        "iso3": "SVN",
        "iso2": "SI",
        "name": "Slovenia",
        "grade": "A+"
    },
    {
        "iso3": "SWE",
        "iso2": "SE",
        "name": "Sweden",
        "grade": "A+"
    },
    {
        "iso3": "SWZ",
        "iso2": "SZ",
        "name": "Swaziland",
        "grade": "B"
    },
    {
        "iso3": "SXM",
        "iso2": "SX",
        "name": "Sint Maarten",
        "grade": "B"
    },
    {
        "iso3": "SYC",
        "iso2": "SC",
        "name": "Seychelles",
        "grade": "B"
    },
    {
        "iso3": "SYR",
        "iso2": "SY",
        "name": "Syrian Arab Republic",
        "grade": "B"
    },
    {
        "iso3": "TCD",
        "iso2": "TD",
        "name": "Chad",
        "grade": "B"
    },
    {
        "iso3": "TGO",
        "iso2": "TG",
        "name": "Togo",
        "grade": "B"
    },
    {
        "iso3": "THA",
        "iso2": "TH",
        "name": "Thailand",
        "grade": "B"
    },
    {
        "iso3": "TJK",
        "iso2": "TJ",
        "name": "Tajikistan",
        "grade": "B"
    },
    {
        "iso3": "TKL",
        "iso2": "TK",
        "name": "Tokelau",
        "grade": "B"
    },
    {
        "iso3": "TKM",
        "iso2": "TM",
        "name": "Turkmenistan",
        "grade": "B"
    },
    {
        "iso3": "TON",
        "iso2": "TO",
        "name": "Tonga",
        "grade": "B"
    },
    {
        "iso3": "TTO",
        "iso2": "TT",
        "name": "Trinidad and Tobago",
        "grade": "B"
    },
    {
        "iso3": "TUN",
        "iso2": "TN",
        "name": "Tunisia",
        "grade": "B"
    },
    {
        "iso3": "TUR",
        "iso2": "TR",
        "name": "Turkey",
        "grade": "B"
    },
    {
        "iso3": "TUV",
        "iso2": "TV",
        "name": "Tuvalu",
        "grade": "B"
    },
    {
        "iso3": "TWN",
        "iso2": "TW",
        "name": "Taiwan",
        "grade": "A"
    },
    {
        "iso3": "UGA",
        "iso2": "UG",
        "name": "Uganda",
        "grade": "B"
    },
    {
        "iso3": "UKR",
        "iso2": "UA",
        "name": "Ukraine",
        "grade": "A"
    },
    {
        "iso3": "UMI",
        "iso2": "UM",
        "name": "United States Minor Outlying Islands",
        "grade": "A+"
    },
    {
        "iso3": "URY",
        "iso2": "UY",
        "name": "Uruguay",
        "grade": "A"
    },
    {
        "iso3": "USA",
        "iso2": "US",
        "name": "United States",
        "grade": "A+"
    },
    {
        "iso3": "UZB",
        "iso2": "UZ",
        "name": "Uzbekistan",
        "grade": "B"
    },
    {
        "iso3": "VAT",
        "iso2": "VA",
        "name": "Holy See",
        "grade": "A+"
    },
    {
        "iso3": "VCT",
        "iso2": "VC",
        "name": "Saint Vincent and the Grenadines",
        "grade": "B"
    },
    {
        "iso3": "VEN",
        "iso2": "VE",
        "name": "Venezuela",
        "grade": "A"
    },
    {
        "iso3": "VIR",
        "iso2": "VI",
        "name": "Virgin Islands, U.S.",
        "grade": "A+"
    },
    {
        "iso3": "VNM",
        "iso2": "VN",
        "name": "Viet Nam",
        "grade": "B"
    },
    {
        "iso3": "VUT",
        "iso2": "VU",
        "name": "Vanuatu",
        "grade": "B"
    },
    {
        "iso3": "WLF",
        "iso2": "WF",
        "name": "Wallis and Futuna",
        "grade": "B"
    },
    {
        "iso3": "WSM",
        "iso2": "WS",
        "name": "Samoa",
        "grade": "B"
    },
    {
        "iso3": "YEM",
        "iso2": "YE",
        "name": "Yemen",
        "grade": "B"
    },
    {
        "iso3": "ZAF",
        "iso2": "ZA",
        "name": "South Africa",
        "grade": "A+"
    },
    {
        "iso3": "ZMB",
        "iso2": "ZM",
        "name": "Zambia",
        "grade": "B"
    },
    {
        "iso3": "ZWE",
        "iso2": "ZW",
        "name": "Zimbabwe",
        "grade": "B"
    }
];